<template>
  <div class="web-navigate" :class="showTitle?'title-down':'title-up'">
      <div class="navagate-area">
        <div class="logo">
           <img src="static/img/logo_slices2.png" class="ge-logo"/>
           <img src="static/img/menu.png" class="menu-button"/>
        </div>
        <div class="menu-list">
          <div @click="goTo('/')" :class="menu=='1'?'current':''">首页</div>
          <div @click="goTo('/deptIntroduction')" :class="menu=='2'?'current':''">业务介绍</div>

          <div @click="goTo('/corporateCulture')" :class="menu=='3'?'current':''">员工故事</div>
   <!--  US202402025  zhangwenxing    校招职位和社招职位 位置互换     -->
          <div @click="goTo('/schoolEnrollment')" :class="menu=='5'?'current':''">校招职位</div>
          <div @click="goTo('/socialRecruitment')" :class="menu=='4'?'current':''">社招职位</div>
          <div @click="goTo('/activityInformation')" :class="menu=='6'?'current':''">活动信息</div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'WebHeader',
  props: {
    menu:{
      type:String,
      required:false,
      default:null
    }
  },
  data () {
    return {
      scrollHeight:0,
      showTitle:true
    }
  },
  watch: {
    scrollHeight(newVal,oldVal) {
      if(newVal>oldVal&&newVal>window.innerHeight-360){
        this.showTitle = false;
      }else{
        this.showTitle = true;
      }
    }
  },
  mounted() {
   window.addEventListener('scroll',this.scrollHeightMethed)
  },
  methods:{
    scrollHeightMethed(){
      this.scrollHeight = document.documentElement.scrollTop||document.body.scrollTop
    },
    goTo(uri){
      console.log(document.body.clientWidth)
      //加上.catch(err => err)解决路径重复点击报错
      this.$router.push(uri).catch(err => err);
    },
    con(){
      console.log(document.body.clientWidth)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  * {
    margin: 0;
    padding: 0;
  }
  .web-navigate{
    width: 100%;
    height:  100px;
    background-color: rgba(0,0,0,0.65);
    position: fixed;
    top: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 16px;
    z-index: 1000;
    transition: top 1s;
  }
  .title-down{
    top: 0;
  }
  .title-up{
    top: -100px;
  }
  .web-navigate .ge-logo{
    width: 206px;
    height: 47px;
    margin: 0 10px;
  }
  .web-navigate .navagate-area{
    width: 1200px;
    height: 100px;
    display: flex;
    justify-content: space-between;
  }
  .web-navigate .logo > *{
    display: flex;
    align-items: center;
  }
  .web-navigate .menu-list{
    display: flex;
    align-items: center;
    padding: 10px 0;

  }
  .web-navigate .menu-list >div{
    cursor:pointer;
  }



  .web-navigate .menu-list > *{
    height: 40px;
    display: flex;
    align-items: center;
    margin: 0 0px 0 57px;
    font-size: 20px;
  }


/*  .web-navigate .menu-list > *:hover{
!*    color: #6400a0;*!
    color: #A259FF;
  }*/
  .web-navigate .current{
/*    color: #6400a0;*/
   /* color: #A259FF;*/
    /*box-shadow: 0 3px 0 0 #ffffff;*/
    border-top:solid 3px transparent;
    border-bottom: solid 3px #ffffff;
  }
  .web-navigate .menu-button{
    width: 40px;
    height: 40px;
    margin: 0 20px;
  }

  @media only screen and (min-width: 1215px){
    /*大分辨率*/
    .web-navigate .menu-button{
      display: none;
    }

    .web-navigate .logo{
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .web-navigate .menu-list >:hover{
      transform: scale(1.2)
      /*font-size: 2em;*/
    }
  }
  @media only screen and (max-width: 1215px){
    /*小分辨率*/
    .web-navigate{
      height: auto;
      min-height: 70px;
      width: 100vw;
    }
    .web-navigate .logo {
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .web-navigate .menu-list{
      display: none;
      height: 270px;
      flex-direction: column;
      align-items: flex-start;
    }
    .web-navigate .menu-list > *{
      width: 87%;
    }

    .web-navigate .navagate-area{
      flex-direction: column;
      width: 100%;
      height: auto;
      min-height: 70px;
    }
    .web-navigate .menu-list >:hover{
      font-size: 24px;
    }
    .web-navigate .navagate-area:hover .menu-list {
      display: flex;

    }
    .web-navigate .current{
      border-top:solid 5px transparent;
      border-bottom: solid 5px #ffffff;

     /* box-shadow: 0 5px 0 0 #A259FF;*/
      margin-bottom: 10px;
    }

  }

  @media only screen and (max-width: 506px){
    .web-navigate{
      height: auto;
      min-height: 50px;
      width: 100vw;
    }
    .web-navigate .logo {
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .web-navigate .menu-list{
      display: none;
      height: 270px;
      flex-direction: column;
      align-items: flex-start;
    }
    .web-navigate .menu-list > *{
      width: 70%;
    }
    .web-navigate .ge-logo{
      width: 124px;
      height: 28px;
      margin: 0 10px;
    }
    .web-navigate .menu-button{
      width: 24px;
      height: 24px;
      margin: 0 20px;
    }
    .web-navigate .navagate-area{
      flex-direction: column;
      width: 100%;
      height: auto;
      min-height: 50px;
    }
    .web-navigate .menu-list > *{
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/web/header.vue